import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';

import ApiService from '../util/api';
import * as ActionTypes from './types/RegistryCollectionActionTypes';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

export function reset() {
  return {
    type: ActionTypes.RESET,
  };
}

function requestSearch() {
  return {
    type: ActionTypes.REQUEST_SEARCH,
  };
}

function receiveSearch(json) {
  return {
    type: ActionTypes.RECEIVE_SEARCH,
    payload: json,
  };
}

function requestDefaultGiftCard() {
  return {
    type: ActionTypes.REQUEST_DEFAULT_GIFT_CARD,
  };
}

function receivedDefaultGiftCard(json) {
  return {
    type: ActionTypes.RECEIVE_DEFAULT_GIFT_CARD,
    payload: json,
  };
}

function toggleFacetValueAction(facetKey, valueKey) {
  return {
    type: ActionTypes.TOGGLE_FACET_VALUE,
    payload: {
      facetKey,
      valueKey,
    },
  };
}

function requestCollectionItemByCollectionId() {
  return {
    type: ActionTypes.REQUEST_REGISTRY_ITEM_BY_COLLECTION_ITEM_ID,
  };
}

function receivedCollectionItemByCollectionId(data) {
  return {
    type: ActionTypes.RECEIVED_REGISTRY_ITEM_BY_COLLECTION_ITEM_ID,
    payload: data,
  };
}

export function resetFacetValues(facetKey) {
  return {
    type: ActionTypes.RESET_FACET_VALUES,
    payload: {
      facetKey,
    },
  };
}

export function updateSort(sort) {
  return {
    type: ActionTypes.UPDATE_SORT,
    payload: {
      sort,
    },
  };
}

export function selectCollection(collectionObject) {
  return {
    type: ActionTypes.SELECT_COLLECTION,
    payload: {
      collectionObject,
    },
  };
}

function requestAddToRegistry() {
  return {
    type: ActionTypes.REQUEST_ADD_TO_REGISTRY,
  };
}

function receiveAddToRegistry(json) {
  return {
    type: ActionTypes.RECEIVE_ADD_TO_REGISTRY,
    payload: json,
  };
}

export function fetchDefaultGiftCard(isPDP = false) {
  return dispatch => {
    dispatch(requestDefaultGiftCard(isPDP));
    return fetch('/web-api/v1/registry-collection/zola_gift_card', {
      credentials: 'same-origin',
    })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receivedDefaultGiftCard(json)));
  };
}

export function fetchRegistryCollectionItem(collectionItemId) {
  return dispatch => {
    dispatch(requestCollectionItemByCollectionId());
    return fetch(`/web-registry-api/v1/registryCollection/item/${collectionItemId}`, {
      credentials: 'same-origin',
    })
      .then(response => response.json())
      .then(json => dispatch(receivedCollectionItemByCollectionId(json.data)));
  };
}

export function search(groupedByCollection = true, showSingleOptionFacets = false) {
  return (dispatch, getState) => {
    dispatch(requestSearch());

    const sort =
      getState().registryCollections.sort !== '' ? getState().registryCollections.sort : undefined;

    const collectionObjectId =
      getState().registryCollections.selectedCollectionObject?.value !== ''
        ? getState().registryCollections.selectedCollectionObject?.value
        : undefined;
    const request = {
      registry_key: getState().wedding.wedding.slug || getState().publicWebsite.wedding.slug,
      filters: getState().registryCollections.selectedFacetValues,
      sort,
      collection_object_id: collectionObjectId,
      flattened_view: !!sort || (!groupedByCollection && !collectionObjectId),
      grouped_by_collection: groupedByCollection,
      show_single_option_facets: showSingleOptionFacets,
    };

    return fetch('/web-api/v1/registry-collection/search', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(request),
    })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveSearch(json)));
  };
}

export function toggleFacetValue(
  facetKey,
  valueKey,
  groupByCollection = true,
  showSingleOptionFacets = false
) {
  return dispatch => {
    dispatch(toggleFacetValueAction(facetKey, valueKey));
    dispatch(search(groupByCollection, showSingleOptionFacets));
  };
}

export function addToRegistry(data, productShippingZones) {
  return dispatch =>
    ApiService.get('/web-api/v1/registry').then(resp => {
      const fetchedShippingAddressInitials =
        resp && resp.address_view && resp.address_view.state_province_region
          ? resp.address_view.state_province_region
          : 'no address';
      const doesUserLiveInExclusionZone = ['HI', 'AK'].indexOf(fetchedShippingAddressInitials) > -1;

      const isProductInExclusionZone =
        productShippingZones &&
        productShippingZones.length > 0 &&
        productShippingZones.indexOf('US_ALASKA_AND_HAWAII') < 0;
      if (isProductInExclusionZone && doesUserLiveInExclusionZone) {
        const headline = 'Product cannot be shipped to Hawaii or Alaska';
        return dispatch(toastsActions.negative({ headline }));
      }

      dispatch(requestAddToRegistry());
      return ApiService.post('/web-api/v1/registryCollection/add', data)
        .then(json => dispatch(receiveAddToRegistry(json)))
        .catch(err => dispatch(toastsActions.negative({ headline: err.message })));
    });
}
